<template>
	<div class="row">
		<div class="col-md-offset-1 col-md-10">
			
			<div class="panel panel-primary" data-collapsed="0">
			
				<div class="panel-heading">
					<div class="panel-title">
						<i class="fa fa-angle-right"></i> Video Home
					</div>
					
				</div>
				
				<div class="panel-body">
					<form role="form" class="form-horizontal" @submit.prevent="submit($event.target)">

						
						<div class="form-group">
							<label for="editor2" class="col-sm-3 control-label">Cuerpo</label>
							<div class="col-sm-7" >
								<input class="form-control" v-model="row.body" type="url">
							</div>
						</div>				

						<div class="form-group">
							<div class="col-sm-12">
								
								<button type="submit" class="btn btn-success pull-right"><i class="far fa-save"></i> Guardar</button> 
										
							</div>
						</div>
					</form>					
				</div>			
			</div>		
		</div>

	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return {

				customToolbar: [
					[{ 'font': [] }],
					[{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
					['bold', 'italic', 'underline'],
					[{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
					[{ 'list': 'ordered'}, { 'list': 'bullet' }]//,
					//['image', 'code-block']
				],

				row:{
					id:null,
					body:'',
					imageUrl:'',
					
				},
				id:8,
				
			}
		},
		
		methods:{
			getRow(){
				this.$root.isLoading = true;
				axios.get(tools.url("/api/admin/videohome")).then((response)=>{
			    	this.row = response.data;
			    	this.$root.isLoading = false;
			    }).catch((error)=>{
			    	this.$parent.handleErrors(error);
			        this.$root.isLoading = false;
			    });
			},
			submit(form){			

				this.$root.isLoading = true;
				this.$parent.validateAll(()=>{
	
					var data=tools.params(form,this.row);					

					axios.post(tools.url("/api/admin/videohome"),data).then((response)=>{
				    	this.$parent.showMessage("Informacion actualizada correctamente!","success");
				    	this.$root.isLoading = false;
				    }).catch((error)=>{
				    	this.$parent.handleErrors(error);
				        this.$root.isLoading = false;
				    });
					
				},(e)=>{
					console.log(e);
					this.$root.isLoading = false;
				});				
			},
			

		},

		mounted(){
			this.getRow();
		}
	}
</script>